import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import { buildUpiLink } from '../../utils/upi';

const fmt = n => new Intl.NumberFormat('en-IN').format(Math.round(n || 0));

// Manual UPI QR payment step — no gateway order/webhook, staff reconciles from the
// screenshot the customer shares. Kept as its own component so a future real payment
// gateway integration only needs to replace this file's internals, nothing that calls it.
export default function PaymentStep({ amount, note, config }) {
  const [selUpi, setSelUpi] = useState(0);

  if (!amount || amount <= 0) return null;

  const upiEntries = config?.upiEntries || [];
  const activeUpiId = upiEntries[selUpi]?.upiId;
  const upiLink = buildUpiLink({ upiId: activeUpiId, upiName: config?.upiName }, amount, note);

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 18, boxShadow: '0 1px 8px rgba(0,0,0,.08)' }}>
      <div style={{ fontWeight: 700, fontSize: '.95rem', marginBottom: 12 }}>Pay via UPI</div>

      {upiLink ? (
        <div style={{ textAlign: 'center' }}>
          {upiEntries.length > 1 && (
            <div style={{ display: 'flex', gap: 8, marginBottom: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
              {upiEntries.map((e, i) => (
                <button key={i} onClick={() => setSelUpi(i)}
                  style={{ padding: '6px 14px', borderRadius: 8, border: `2px solid ${selUpi === i ? 'var(--primary)' : '#d1d5db'}`,
                    background: selUpi === i ? '#eff6ff' : '#fff', cursor: 'pointer', fontSize: '.8rem', fontWeight: 600 }}>
                  {e.label}
                </button>
              ))}
            </div>
          )}
          <div style={{ display: 'inline-block', background: '#fff', padding: 16, borderRadius: 12, border: '2px solid #e5e7eb', boxShadow: '0 2px 8px rgba(0,0,0,.08)' }}>
            <QRCode value={upiLink} size={200} />
            <div style={{ marginTop: 8, fontSize: '.75rem', color: '#888' }}>
              {config?.upiName || 'AngelNet'} · ₹{fmt(amount)}
            </div>
          </div>
          <p style={{ fontSize: '.78rem', color: '#888', marginTop: 8 }}>
            Scan with PhonePe, GPay, Paytm or any UPI app
          </p>
          <div style={{ marginTop: 10, padding: '8px 12px', background: '#fffbeb', borderRadius: 8, border: '1px solid #fde68a', fontSize: '.8rem', color: '#92400e', display: 'inline-block' }}>
            After paying, share the payment screenshot with your admin for faster update.
          </div>
        </div>
      ) : (
        <p style={{ color: '#888', fontSize: '.85rem', textAlign: 'center' }}>
          UPI payment not available. Contact your admin.
        </p>
      )}
    </div>
  );
}
